import React from 'react';
import styles from './index.module.scss';
import { Flex } from 'antd';
import cx from 'clsx';

const Separator = (props) => {
  const { children, dot, className, style } = props;
  return (
    <Flex
      align="center"
      className={cx(!dot ? styles.itemSeparator : styles.dotSeparator, className)}
      style={{ ...style }}
    >
      {children}
    </Flex>
  );
};

export default Separator;
